import React, { useState } from "react";
import PropTypes from "prop-types";

const CalendarIcon = ({ fill, hoverColor, onClick, size = 20 }) => {
  const [filled, setFilled] = useState(fill);

  return (
    <svg
      style={{ transition: "fill 0.4s", fill: filled }}
      onMouseEnter={(e) => {
        if (hoverColor) {
          setFilled(hoverColor);
        }
      }}
      onMouseLeave={(e) => {
        setFilled(fill);
      }}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 17 19"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ transition: "fill 0.4s", fill: filled, pointerEvents: "none" }}
        onMouseEnter={(e) => {
          if (hoverColor) setFilled(hoverColor);
        }}
        onMouseLeave={(e) => {
          setFilled(fill);
        }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1613 0.833496C12.5063 0.833496 12.7863 1.1135 12.7863 1.4585L12.7867 2.165C14.0035 2.24843 15.014 2.6652 15.7292 3.38191C16.5101 4.16608 16.9209 5.29358 16.9168 6.64608V14.2486C16.9168 17.0252 15.1534 18.7502 12.3159 18.7502H5.26758C2.43008 18.7502 0.666748 17.0011 0.666748 14.1852V6.64441C0.666748 4.02541 2.23929 2.34428 4.80399 2.16529L4.8045 1.4585C4.8045 1.1135 5.0845 0.833496 5.4295 0.833496C5.7745 0.833496 6.0545 1.1135 6.0545 1.4585L6.05425 2.14933H11.5359L11.5363 1.4585C11.5363 1.1135 11.8163 0.833496 12.1613 0.833496ZM15.6667 8.2535H1.91675V14.1852C1.91675 16.3236 3.10675 17.5002 5.26758 17.5002H12.3159C14.4767 17.5002 15.6668 16.3452 15.6668 14.2486L15.6667 8.2535ZM12.5011 13.4971C12.8461 13.4971 13.1261 13.7771 13.1261 14.1221C13.1261 14.4671 12.8461 14.7471 12.5011 14.7471C12.1561 14.7471 11.8727 14.4671 11.8727 14.1221C11.8727 13.7771 12.1486 13.4971 12.4936 13.4971H12.5011ZM8.80316 13.4971C9.14816 13.4971 9.42816 13.7771 9.42816 14.1221C9.42816 14.4671 9.14816 14.7471 8.80316 14.7471C8.45816 14.7471 8.17483 14.4671 8.17483 14.1221C8.17483 13.7771 8.45066 13.4971 8.79566 13.4971H8.80316ZM5.0975 13.4971C5.4425 13.4971 5.7225 13.7771 5.7225 14.1221C5.7225 14.4671 5.4425 14.7471 5.0975 14.7471C4.7525 14.7471 4.46833 14.4671 4.46833 14.1221C4.46833 13.7771 4.745 13.4971 5.09 13.4971H5.0975ZM12.5011 10.2582C12.8461 10.2582 13.1261 10.5382 13.1261 10.8832C13.1261 11.2282 12.8461 11.5082 12.5011 11.5082C12.1561 11.5082 11.8727 11.2282 11.8727 10.8832C11.8727 10.5382 12.1486 10.2582 12.4936 10.2582H12.5011ZM8.80316 10.2582C9.14816 10.2582 9.42816 10.5382 9.42816 10.8832C9.42816 11.2282 9.14816 11.5082 8.80316 11.5082C8.45816 11.5082 8.17483 11.2282 8.17483 10.8832C8.17483 10.5382 8.45066 10.2582 8.79566 10.2582H8.80316ZM5.0975 10.2582C5.4425 10.2582 5.7225 10.5382 5.7225 10.8832C5.7225 11.2282 5.4425 11.5082 5.0975 11.5082C4.7525 11.5082 4.46833 11.2282 4.46833 10.8832C4.46833 10.5382 4.745 10.2582 5.09 10.2582H5.0975ZM11.5359 3.39933H6.05425L6.0545 4.201C6.0545 4.546 5.7745 4.826 5.4295 4.826C5.0845 4.826 4.8045 4.546 4.8045 4.201L4.80405 3.41825C2.9372 3.57507 1.91675 4.70671 1.91675 6.64441V7.0035H15.6667L15.6668 6.64441C15.6701 5.61525 15.3934 4.81525 14.8442 4.26525C14.3622 3.78175 13.6575 3.493 12.787 3.41865L12.7863 4.201C12.7863 4.546 12.5063 4.826 12.1613 4.826C11.8163 4.826 11.5363 4.546 11.5363 4.201L11.5359 3.39933Z"
        fill={fill}
      />
    </svg>
  );
};
CalendarIcon.propTypes = {
  fill: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,

  onClick: PropTypes.func,
  size: PropTypes.number,
};

export default CalendarIcon;
